const connections = {
    'clients.connections': 'Connections',
    'clients.connections.add': 'Add connection',
    'clients.connections.edit': 'Edit connection',
    'clients.connections.edit.save': 'Save connection',

    'clients.connections.categories.combine': 'Combinable fields',
    'clients.connections.categories.draganddrop': 'Drag the fields to combine',
    'clients.connections.categories.combine.complete': 'Save combinations',

    'clients.connections.categories.add': 'Add category',
    'clients.connections.categories.add.name': 'Name of new category',
    'clients.connections.categories.mode.combine': 'Leave edit mode',
    'clients.connections.categories.mode.edit': 'Start edit mode',
    'clients.connections.categories.edit.name': 'Change the name of the category',

    'clients.connections.brands.combine': 'Combinable fields',
    'clients.connections.brands.draganddrop': 'Drag the fields to combine',
    'clients.connections.brands.combine.complete': 'Save combinations',
    'clients.connections.brands.edit.name': 'Change the name of the brand',

    'clients.connections.brands.add': 'Add brand',
    'clients.connections.brands.add.name': 'Name of the new brand',
    'clients.connections.brands.save': 'Save brand',
    'clients.connections.brands.edit': 'Edit brand',

    'clients.connections.pricing.add': 'Save prices',
    'clients.connections.pricing.edit': 'Save changes',

    'clients.connections.pricing.brand': 'Brand',
    'clients.connections.pricing.category': 'Category',
    'clients.connections.pricing.min': 'Minimal price',
    'clients.connections.pricing.max': 'Maximum price',
    'clients.connections.pricing.marge': 'Price margin ( percentage )',
    'clients.connections.pricing.vat_percentage': 'VAT class',

    'clients.connections.status': 'Status',
    'clients.connections.general': 'General',
    'clients.connections.active': 'Activated',
    'clients.connections.dryrun': 'Dry Run',
    'clients.connections.name': 'Name',
    'clients.connections.webshop': 'Webshop',
    'clients.connections.store_view': 'Shop number',
    'clients.connections.feed': 'Feed',
    'clients.connections.configbase': 'Configuration based on',
    'clients.connections.configbase.feed': 'Feed',
    'clients.connections.configbase.webshop': 'Webshop',
    'clients.connections.variants': 'Variants',
    'clients.connections.use_variants': 'Use variants',
    'clients.connections.variant_match_field': 'Combine variants on',
    'clients.connections.vat_settings': 'VAT settings',
    'clients.connections.vat_include': 'Price incl. VAT in webshop',
    'clients.connections.vat_calculate': 'Calculate VAT',
    'clients.connections.vat_percentage': 'VAT percentage',
    'clients.connections.prefix': 'Prefix for article numbers',

    'clients.connections.seo.settings': 'SEO settings',
    'clients.connections.seo.active': 'SEO active',

    'clients.connections.provider.settings': 'Provider settings',
    'clients.connections.provider.active': 'Provider active',
    'clients.connections.provider': 'Provider',
    'clients.connections.provider.username': 'User name',
    'clients.connections.provider.password': 'Password',
    'clients.connections.provider.infobar.icecat': 'For full functionality, the IP address of our application and of your webshop must be included in the whitelist of IceCat. The IP address of our application is: 159.69.121.84',
    'clients.connections.provider.infobar.language': 'Specify which language is gonna be used by the content-provider',

    'clients.connections.notifications': 'Notifications',
    'clients.connections.notifications.administrative': 'Administrative',

    'clients.connections.settings': 'Settings',
    'clients.connections.categories': 'Categories',
    'clients.connections.brands': 'Brands',
    'clients.connections.attributes': 'Attributes',
    'clients.connections.pricing': 'Pricing',
    'clients.connections.all_products': 'All products',
    'clients.connections.sync': 'Synchronise',
    'clients.connections.sync_settings': 'Synchronisation settings',

    'clients.connections.synchronized': 'Synchronized',
    'clients.connections.products.notifications': 'Notifications',
    'clients.connections.product.edit': 'Edit product',
    'clients.connections.product': 'Product',
    'clients.connections.product.name': 'Product name',
    'clients.connections.product.brand': 'Brand',
    'clients.connections.product.category': 'Category',
    'clients.connections.product.pricing': 'Price',
    'clients.connections.product.number': 'Product number',
    'clients.connections.product.select.all': 'Select all products',
    'clients.connections.product.saving': 'Send product information data',
    'clients.connections.product.save': 'Save product information',
    'clients.connections.product.show': 'Show product in the webshop',
    'clients.connections.product.meta_title': 'SEO title',
    'clients.connections.product.meta_description': 'SEO description',
    'clients.connections.product.meta_keywords': 'SEO keywords',

    'clients.connections.product.exception': 'Exception',
    'clients.connections.product.type': 'Type',
    'clients.connections.product.batch_number': 'Batch number',
    'clients.connections.product.row_number': 'Row number',
    'clients.connections.product.unqiue_code': 'Unique code',
    'clients.connections.product.job': 'Job',

    'clients.connections.status.queue': 'In queue',
    // 'clients.connections.status.collecting': 'Picking up products',
    // 'clients.connections.status.collecting-cp': 'Picking up products from content-provider',
    'clients.connections.status.syncing': 'In synchronisation',
    'clients.connections.status.finished': 'Synchronised',
    'clients.connections.status.failed': 'Synchronisation failed',
    // 'clients.connections.status.deleting': 'Deleting products',

    'clients.connections.status.synchronizing': 'Synchronizing',
    'clients.connections.status.updating': 'Updating',
    'clients.connections.status.product_feed.downloading': 'Download dependencies',
    'clients.connections.status.product_feed.reading': 'Loading products',
    'clients.connections.status.product_feed.collecting': 'Validating products',
    // 'clients.connections.status.product_feed.content_provider': 'productdata available from content provider',
    'clients.connections.status.product_feed.syncing': 'Syncing products',
    'clients.connections.status.product_feed.deleting': 'Cleanup products',

    'clients.connections.products.edit': 'Edit Product',

    'clients.connections.language.shopname': 'Shop language',
    'clients.connections.language.code': 'Language code',
    'clients.connections.language.icecat.language': 'IceCat language',
    'clients.connections.provider.language.infobar.icecat_language': 'Select the language to be loaded from the content provider IceCat. If the information is not available in this language in IceCat, the linked fields below will be used for translation.',
    'clients.connections.language.related': 'Related',
    'clients.connections.language.cross_sell': 'Similar',

    'clients.connection.customergroup.type': 'Group type',
    'clients.connection.customergroup.options.business_to_business_price': 'Business to business price',
    'clients.connection.customergroup.discount': 'Discount (percentage)',
    'clients.connection.customergroup.b2b_inc': 'Business to business price includes VAT',

    'clients.connections.attributes.use_as_variant': 'Make variant based on the property',

    'clients.connections.labels.settings': 'Label settings (Shopware 6 only)',
    'clients.connections.labels.label_related': 'Related',
    'clients.connections.labels.label_cross_sell': 'Similar',

    'clients.connections.stock.settings': 'Stock settings (Shopware 6 only)',
    'clients.connections.stock.restock_time': 'Restock time',
    'clients.connections.stock.clearance_sale': 'Clearance sales',
    'clients.connections.stock.delivery_time': 'Delivery time',
};

export default connections;
